import { Icons } from "@/assets";
import { cx } from "@/utils/cx";

interface SearchBarProps {
    placeholder?: string;
    value?: string;
    onChange?: (value: string) => void;
    className?: string;
    inputClassName?: string;
}

export const SearchBar = ({
    placeholder = "Search...",
    value,
    onChange,
    className,
    inputClassName,
}: SearchBarProps) => {
    return (
        <div className={cx("relative", className)}>
            <div className="pointer-events-none absolute inset-y-0 left-0 pl-4 flex items-center">
                <Icons.SearchIcon className="w-6 h-6 text-brand"/>
            </div>
            <input
                type="text"
                placeholder={placeholder}
                value={value}
                onChange={(e) => onChange?.(e.target.value)}
                className={cx("w-full h-[48px] rounded-xl border border-gray-30 bg-white pl-12 pr-2 text-sm text-gray-110 placeholder:text-gray-60 outline-none transition-all focus:border-transparent focus:ring-2 focus:ring-brand",inputClassName)}
            />
        </div>
    );
};
